<template>
  <AdSummarySkeleton v-if="loading"></AdSummarySkeleton>
  <div v-else>
    <div class="card-content">
      <ShopProfile :sellerShop="sellerShop" :loading="isShopLoading" />
      <div class="quick-access">
        <QuickAccess :cardItems="cardItems" />
      </div>
    </div>
    <div class="card-footer">
      <div class="title">
        <div v-if="adData?.footerIcon">
          <img
            :src="require(`@/assets/images/icons/${adData?.footerIcon}.svg`)"
            alt="icon"
          />
        </div>
        <div>
          <div>
            <span :class="{ gift: adData.gift }">{{ adData?.title }}</span>
          </div>
          <div v-if="adData?.footerTitle">
            <span
              :class="{ 'footer-title': adData?.footerTitle }"
              @click="footerTitleHref"
            >
              {{ adData?.footerTitle }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Card, Hr, AppButton } from "@n11/so-ui-components";
import AdSummarySkeleton from "./AdSummarySkeleton";
import QuickAccess from "@/components/QuickAccess/QuickAccess.vue";
import listIcon from "@/assets/images/icons/list-primary.svg";
import actionsIcon from "@/assets/images/icons/actions-primary.svg";
import viewIcon from "@/assets/images/icons/view-primary.svg";
import message from "@/assets/images/icons/icon-message.svg";
import ShopProfile from "@/components/ShopProfile/ShopProfile";
export default {
  name: "AdSummary",
  components: {
    Hr,
    AppButton,
    AdSummarySkeleton,
    Card,
    QuickAccess,
    ShopProfile,
  },

  props: {
    adData: {
      type: Object,
      required: true,
    },
    sellerShop: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },

  computed: {
    ...mapGetters({
      sellerTicketCount: "dashboard/getSellerTicketCount",
      n11TicketCount: "dashboard/getN11TicketCount",
    }),
    cardItems() {
      return [
        {
          href: "https://magazadestek.n11.com/talepler",
          target: "_blank",
          icon: listIcon,
          label: " Destek <br> Taleplerim",
          notification: this.sellerTicketCount,
        },
        {
          href: "https://magazadestek.n11.com/mesajlar",
          target: "_blank",
          icon: message,
          label: "n11’den <br> Mesajlarım",
          notification: this.n11TicketCount,
        },
        {
          href: "/selleroffice/product/productWatchCounts",
          icon: actionsIcon,
          label: "Favoriye Eklenen <br> Ürünlerim",
        },
        {
          href: "/selleroffice/app/analytics",
          icon: viewIcon,
          label: "Görüntülenen <br> Ürünlerim",
        },
      ];
    },
  },
  methods: {
    footerTitleHref() {
      window.location.href = this.adData.footerTitleHref;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/mobiles.scss";

.card-content {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 0;

  &-item {
    background: $colorM05;
    border-radius: 8px;
    gap: 35px;
    display: flex;
    align-items: center;
    padding: 16px 12px;

    .rp-point-content {
      gap: 4px;
      align-items: center;
    }

    span {
      font-size: 14px;
      color: $dark-gray-5;
      font-weight: 600;
    }
  }

  .user-summary-store-name {
    align-items: center;
    gap: 16px;
    max-width: 50%;
    span {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: -0.05px;
      white-space: nowrap;
    }
  }

  .user-summary-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 64 64' xmlns:v='https://vecta.io/nano'%3E%3Cstyle%3E%3C!%5BCDATA%5B.B%7Bcolor-interpolation-filters:sRGB%7D.C%7Bflood-opacity:0%7D.D%7Bfill:%23edeff3%7D.E%7Bfill:%23ffd10d%7D.F%7Bfill:%23a38712%7D%5D%5D%3E%3C/style%3E%3Cg filter='url(%23D)'%3E%3Cpath d='M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32 14.327 0 32 0s32 14.327 32 32z' fill='%23beb2e4'/%3E%3C/g%3E%3Cg filter='url(%23E)'%3E%3Cpath d='M58.667 32c0 14.728-11.939 26.667-26.667 26.667S5.333 46.728 5.333 32 17.272 5.333 32 5.333 58.667 17.272 58.667 32z' fill='%237d65c9'/%3E%3C/g%3E%3Cg filter='url(%23F)'%3E%3Cpath d='M59.719 48H4.281C9.814 57.565 20.155 64 32 64s22.186-6.435 27.719-16z' fill='url(%23K)' fill-rule='evenodd'/%3E%3C/g%3E%3Cmask id='A' x='5' y='5' width='54' height='54' maskUnits='userSpaceOnUse' mask-type='alpha'%3E%3Cpath d='M58.667 32c0 14.728-11.939 26.667-26.667 26.667S5.333 46.728 5.333 32 17.272 5.333 32 5.333 58.667 17.272 58.667 32z' fill='%235d3ebc'/%3E%3C/mask%3E%3Cg mask='url(%23A)'%3E%3Cg filter='url(%23G)'%3E%3Cg filter='url(%23H)'%3E%3Cpath d='M14.222 19.556a.71.71 0 0 1 .711-.711h25.148v29.091H14.222v-28.38z' fill='url(%23L)'/%3E%3C/g%3E%3Cpath d='M14.756 19.556c0-.098.08-.178.178-.178h24.614v28.024H14.756V19.556z' stroke='%23f2f0fa' stroke-width='1.067'/%3E%3Cg filter='url(%23I)'%3E%3Cmask id='B' fill='%23fff'%3E%3Cpath d='M22.756 38.044a.71.71 0 0 1 .711-.711h7.111a.71.71 0 0 1 .711.711V48h-8.533v-9.955z'/%3E%3C/mask%3E%3Cpath d='M22.756 38.044a.71.71 0 0 1 .711-.711h7.111a.71.71 0 0 1 .711.711V48h-8.533v-9.955z' fill='url(%23M)'/%3E%3Cpath d='M21.689 38.044a1.78 1.78 0 0 1 1.778-1.778h7.111a1.78 1.78 0 0 1 1.778 1.778l-2.133.355h-6.4l-2.133-.355zm9.6 9.956h-8.533 8.533zm-9.6 0v-9.955a1.78 1.78 0 0 1 1.778-1.778l.356 2.133V48h-2.133zm8.889-11.733a1.78 1.78 0 0 1 1.778 1.778V48h-2.133v-9.6l.355-2.133z' fill='%23f2f0fa' mask='url(%23B)'/%3E%3C/g%3E%3Cpath d='M40.081 18.844h8.808a.89.89 0 0 1 .889.889v28.202h-9.697V18.844z' fill='url(%23N)'/%3E%3C/g%3E%3C/g%3E%3Cpath fill='url(%23O)' d='M15.644 19.911h23.111v22.756H15.644z'/%3E%3Cmask id='C' x='14' y='19' width='25' height='29' maskUnits='userSpaceOnUse' mask-type='alpha'%3E%3Cpath fill='%237d65c9' d='M14.222 19.911h24.533V48H14.222z'/%3E%3C/mask%3E%3Cg mask='url(%23C)'%3E%3Cg filter='url(%23J)'%3E%3Cuse href='%23S' class='E'/%3E%3Cuse href='%23T' class='E'/%3E%3Cuse href='%23U' class='E'/%3E%3Cuse href='%23V' fill='%23fff'/%3E%3Cuse href='%23T' x='-3.911' fill='%23fff'/%3E%3Cpath d='M34.844 19.911h3.911L35.2 24.889h-3.911l3.556-4.978z' fill='%23fff'/%3E%3Cuse href='%23W' class='F'/%3E%3Cuse href='%23X' class='D'/%3E%3Cuse href='%23X' x='3.911' class='F'/%3E%3Cuse href='%23W' x='11.734' class='D'/%3E%3Cuse href='%23X' x='11.734' class='F'/%3E%3Cuse href='%23Y' class='D'/%3E%3C/g%3E%3C/g%3E%3Cg class='E'%3E%3Cuse href='%23S'/%3E%3Cuse href='%23V' x='-3.911'/%3E%3Cuse href='%23T' x='7.823'/%3E%3C/g%3E%3Cg fill='%23fff'%3E%3Cuse href='%23T' x='3.911'/%3E%3Cuse href='%23T' x='-3.911'/%3E%3Cuse href='%23U' x='3.912'/%3E%3C/g%3E%3Cuse href='%23W' fill='url(%23P)'/%3E%3Cuse href='%23X' class='D'/%3E%3Cuse href='%23W' x='7.823' fill='url(%23Q)'/%3E%3Cuse href='%23X' x='7.823' class='D'/%3E%3Cuse href='%23X' x='11.734' fill='url(%23R)'/%3E%3Cuse href='%23Y' class='D'/%3E%3Cdefs%3E%3Cfilter id='D' x='0' y='-1.778' width='64' height='67.556' filterUnits='userSpaceOnUse' class='B'%3E%3CfeFlood class='C'/%3E%3CfeBlend in='SourceGraphic' result='B'/%3E%3CfeColorMatrix in='SourceAlpha' result='C' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='1.77778'/%3E%3CfeGaussianBlur stdDeviation='2.133'/%3E%3CfeComposite in2='C' k2='-1' k3='1' operator='arithmetic'/%3E%3CfeColorMatrix values='0 0 0 0 0.490196 0 0 0 0 0.396078 0 0 0 0 0.788235 0 0 0 0.3 0'/%3E%3CfeBlend in2='B' result='D'/%3E%3CfeColorMatrix in='SourceAlpha' result='C' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='-1.77778'/%3E%3CfeGaussianBlur stdDeviation='2.133'/%3E%3CfeComposite in2='C' k2='-1' k3='1' operator='arithmetic'/%3E%3CfeColorMatrix values='0 0 0 0 0.490196 0 0 0 0 0.396078 0 0 0 0 0.788235 0 0 0 0.3 0'/%3E%3CfeBlend in2='D'/%3E%3C/filter%3E%3Cfilter id='E' x='5.333' y='3.2' width='53.333' height='57.6' filterUnits='userSpaceOnUse' class='B'%3E%3CfeFlood class='C'/%3E%3CfeBlend in='SourceGraphic' result='B'/%3E%3CfeColorMatrix in='SourceAlpha' result='C' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='2.13333'/%3E%3CfeGaussianBlur stdDeviation='2.133'/%3E%3CfeComposite in2='C' k2='-1' k3='1' operator='arithmetic'/%3E%3CfeColorMatrix values='0 0 0 0 0.258824 0 0 0 0 0.184314 0 0 0 0 0.482353 0 0 0 0.5 0'/%3E%3CfeBlend in2='B' result='D'/%3E%3CfeColorMatrix in='SourceAlpha' result='C' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='-2.13333'/%3E%3CfeGaussianBlur stdDeviation='2.133'/%3E%3CfeComposite in2='C' k2='-1' k3='1' operator='arithmetic'/%3E%3CfeColorMatrix values='0 0 0 0 0.258824 0 0 0 0 0.184314 0 0 0 0 0.482353 0 0 0 0.5 0'/%3E%3CfeBlend in2='D'/%3E%3C/filter%3E%3Cfilter id='F' x='4.281' y='40.889' width='55.438' height='30.222' filterUnits='userSpaceOnUse' class='B'%3E%3CfeFlood class='C'/%3E%3CfeBlend in='SourceGraphic' result='B'/%3E%3CfeColorMatrix in='SourceAlpha' result='C' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='7.11111'/%3E%3CfeGaussianBlur stdDeviation='3.556'/%3E%3CfeComposite in2='C' k2='-1' k3='1' operator='arithmetic'/%3E%3CfeColorMatrix values='0 0 0 0 0.258824 0 0 0 0 0.184314 0 0 0 0 0.482353 0 0 0 1 0'/%3E%3CfeBlend in2='B' result='D'/%3E%3CfeColorMatrix in='SourceAlpha' result='C' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='-7.11111'/%3E%3CfeGaussianBlur stdDeviation='3.556'/%3E%3CfeComposite in2='C' k2='-1' k3='1' operator='arithmetic'/%3E%3CfeColorMatrix values='0 0 0 0 0.19332 0 0 0 0 0.117483 0 0 0 0 0.420833 0 0 0 1 0'/%3E%3CfeBlend in2='D'/%3E%3C/filter%3E%3Cfilter id='G' x='7.822' y='15.289' width='48.356' height='39.111' filterUnits='userSpaceOnUse' class='B'%3E%3CfeFlood result='A' class='C'/%3E%3CfeColorMatrix in='SourceAlpha' result='B' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dx='1.42222' dy='1.42222'/%3E%3CfeGaussianBlur stdDeviation='2.489'/%3E%3CfeComposite in2='B' operator='out'/%3E%3CfeColorMatrix values='0 0 0 0 0.258824 0 0 0 0 0.184314 0 0 0 0 0.482353 0 0 0 0.7 0'/%3E%3CfeBlend in2='A' result='C'/%3E%3CfeColorMatrix in='SourceAlpha' result='B' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dx='-1.42222' dy='1.42222'/%3E%3CfeGaussianBlur stdDeviation='2.489'/%3E%3CfeComposite in2='B' operator='out'/%3E%3CfeColorMatrix values='0 0 0 0 0.258824 0 0 0 0 0.184314 0 0 0 0 0.482353 0 0 0 0.5 0'/%3E%3CfeBlend in2='C'/%3E%3CfeBlend in='SourceGraphic'/%3E%3C/filter%3E%3Cfilter id='H' x='14.222' y='18.844' width='27.281' height='29.091' filterUnits='userSpaceOnUse' class='B'%3E%3CfeFlood class='C'/%3E%3CfeBlend in='SourceGraphic' result='B'/%3E%3CfeColorMatrix in='SourceAlpha' result='C' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dx='1.42222'/%3E%3CfeGaussianBlur stdDeviation='.711'/%3E%3CfeComposite in2='C' k2='-1' k3='1' operator='arithmetic'/%3E%3CfeColorMatrix values='0 0 0 0 0.309804 0 0 0 0 0.215686 0 0 0 0 0.607843 0 0 0 0.5 0'/%3E%3CfeBlend in2='B'/%3E%3C/filter%3E%3Cfilter id='I' x='22.4' y='36.267' width='10.667' height='12.8' filterUnits='userSpaceOnUse' class='B'%3E%3CfeFlood result='A' class='C'/%3E%3CfeColorMatrix in='SourceAlpha' result='B' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dx='0.711111'/%3E%3CfeGaussianBlur stdDeviation='.533'/%3E%3CfeComposite in2='B' operator='out'/%3E%3CfeColorMatrix values='0 0 0 0 0.309804 0 0 0 0 0.215686 0 0 0 0 0.607843 0 0 0 0.2 0'/%3E%3CfeBlend in2='A'/%3E%3CfeBlend in='SourceGraphic' result='D'/%3E%3CfeColorMatrix in='SourceAlpha' result='B' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dx='1.42222' dy='0.711111'/%3E%3CfeGaussianBlur stdDeviation='.711'/%3E%3CfeComposite in2='B' k2='-1' k3='1' operator='arithmetic'/%3E%3CfeColorMatrix values='0 0 0 0 0.309804 0 0 0 0 0.215686 0 0 0 0 0.607843 0 0 0 0.7 0'/%3E%3CfeBlend in2='D'/%3E%3C/filter%3E%3Cfilter id='J' x='9.955' y='18.844' width='30.578' height='11.378' filterUnits='userSpaceOnUse' class='B'%3E%3CfeFlood result='A' class='C'/%3E%3CfeColorMatrix in='SourceAlpha' result='B' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='0.711111'/%3E%3CfeGaussianBlur stdDeviation='.889'/%3E%3CfeComposite in2='B' operator='out'/%3E%3CfeColorMatrix values='0 0 0 0 0.309804 0 0 0 0 0.215686 0 0 0 0 0.607843 0 0 0 0.4 0'/%3E%3CfeBlend in2='A'/%3E%3CfeBlend in='SourceGraphic'/%3E%3C/filter%3E%3ClinearGradient id='K' x1='32' x2='32' y1='43.286' y2='64' href='%23Z'%3E%3Cstop stop-color='%235d3ebc' offset='0'/%3E%3Cstop stop-color='%234f379b' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='L' x1='27.152' x2='27.152' y1='18.844' y2='47.935' href='%23Z'%3E%3Cstop stop-color='%23f2f0fa' offset='0'/%3E%3Cstop stop-color='%23dfd8f2' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='M' x1='27.022' x2='27.022' y1='37.333' y2='48' href='%23Z'%3E%3Cstop stop-color='%239e8bd7' offset='0'/%3E%3Cstop stop-color='%237d65c9' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='N' x1='44.929' x2='44.929' y1='18.844' y2='47.935' href='%23Z'%3E%3Cstop stop-color='%23beb2e4' offset='0'/%3E%3Cstop stop-color='%239e8bd7' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='O' x1='27.2' x2='27.2' y1='19.911' y2='42.667' href='%23Z'%3E%3Cstop stop-color='%237d65c9' offset='0'/%3E%3Cstop stop-color='%23beb2e4' stop-opacity='0' offset='.708'/%3E%3C/linearGradient%3E%3ClinearGradient id='P' x1='13.689' x2='13.689' y1='24.889' y2='27.733' href='%23Z'%3E%3Cstop stop-color='%23e4bb0d' offset='0'/%3E%3Cstop stop-color='%23dbb205' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='Q' x1='13.688' x2='13.688' y1='24.889' y2='27.733' href='%23Z'%3E%3Cstop stop-color='%23e4bb0d' offset='0'/%3E%3Cstop stop-color='%23dbb205' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='R' x1='17.6' x2='17.6' y1='24.889' y2='27.733' href='%23Z'%3E%3Cstop stop-color='%23e4bb0d' offset='0'/%3E%3Cstop stop-color='%23dbb205' offset='1'/%3E%3C/linearGradient%3E%3Cpath id='S' d='M15.289 19.911H19.2l-3.556 4.978h-3.911l3.556-4.978z'/%3E%3Cpath id='T' d='M23.111 19.911h3.911l-3.556 4.978h-3.911l3.556-4.978z'/%3E%3Cpath id='U' d='M30.933 19.911h3.911l-3.556 4.978h-3.911l3.555-4.978z'/%3E%3Cpath id='V' d='M27.022 19.911h3.911l-3.555 4.978h-3.911l3.555-4.978z'/%3E%3Cpath id='W' d='M11.733 24.889h3.911v.889c0 1.08-.876 1.956-1.956 1.956s-1.956-.876-1.956-1.956v-.889z'/%3E%3Cpath id='X' d='M15.644 24.889h3.911v.889c0 1.08-.875 1.956-1.956 1.956s-1.956-.876-1.956-1.956v-.889z'/%3E%3Cpath id='Y' d='M31.289 24.889H35.2v.889c0 1.08-.876 1.956-1.956 1.956s-1.956-.876-1.956-1.956v-.889z'/%3E%3ClinearGradient id='Z' gradientUnits='userSpaceOnUse'/%3E%3C/defs%3E%3C/svg%3E");
  }

  &-title {
    display: flex;
    justify-content: flex-start;
  }

  &-result {
    strong {
      display: block;
      font-size: 14px;
      font-weight: 700;
      line-height: normal;
      letter-spacing: -0.05px;
      color: $dark-gray-5;
    }

    span {
      display: block;
      color: $colorN80;
      text-align: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
    }
  }

  .user-summary-info {
    font-size: 11px;
    color: $dark-gray-5;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.05px;
  }

  .quick-access {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    align-items: center;
  }
}

.card-footer {
  width: 100%;
  display: none;
  justify-content: space-between;

  .title {
    width: 65%;
    display: flex;
    align-items: center;

    span {
      font-size: 12px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: -0.05px;
      color: $dark-gray-5;
    }

    .footer-title {
      color: $blue-5 !important;
      cursor: pointer;
    }

    .gift {
      color: $green-6 !important;
    }
  }

  .button {
    display: flex;
    justify-content: flex-end;
  }
}

.hr {
  margin: 10px 0;
}
@media screen and (max-width: 1440px) {
  .card-content {
    &-result {
      strong {
        font-size: 14px !important;
      }
    }
  }
}
@media screen and (max-width: 1220px) {
  .card-content {
    &-result {
      strong {
        font-size: 14px !important;
      }
    }
  }
  .card-footer {
    .title {
      span {
        font-size: 10px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .card-content {
    flex-direction: column;
    gap: 13px;
    &-result {
      strong {
        font-size: 13px !important;
      }
    }
    .rp-point-content {
      white-space: nowrap;
    }

    &-item {
      span {
        font-size: 13px;
      }
    }

    .user-summary-store-name {
      font-size: 14px;
      width: 100%;
      justify-content: center;
    }

    .user-summary-icon {
      width: 36px;
      height: 36px;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='36px' height='36px' viewBox='0 0 36 36' version='1.1'%3E%3Cdefs%3E%3Cfilter id='alpha' filterUnits='objectBoundingBox' x='0%25' y='0%25' width='100%25' height='100%25'%3E%3CfeColorMatrix type='matrix' in='SourceGraphic' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'/%3E%3C/filter%3E%3Cimage id='image7' width='36' height='36' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAIAAABuYg/PAAAABmJLR0QA/wD/AP+gvaeTAAAALUlEQVRIie3NMQ0AMAgAsDH8OyYBFXC1Bhpd+a78s0kmk8lkMplMJpPJZLJ1A79cAkacbV2NAAAAAElFTkSuQmCC'/%3E%3Cmask id='mask0'%3E%3Cg filter='url(%23alpha)'%3E%3Cuse xlink:href='%23image7'/%3E%3C/g%3E%3C/mask%3E%3CclipPath id='clip1'%3E%3Crect x='0' y='0' width='36' height='36'/%3E%3C/clipPath%3E%3Cg id='surface6' clip-path='url(%23clip1)'%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 37.5 6 C 38.296875 6 39.057292 6.317708 39.619792 6.880208 C 40.182292 7.442708 40.5 8.203125 40.5 9 L 40.5 27 C 40.5 27.796875 40.182292 28.557292 39.619792 29.119792 C 39.057292 29.682292 38.296875 30 37.5 30 L 10.5 30 C 9.703125 30 8.942708 29.682292 8.380208 29.119792 C 7.817708 28.557292 7.5 27.796875 7.5 27 L 7.5 9 C 7.5 8.203125 7.817708 7.442708 8.380208 6.880208 C 8.942708 6.317708 9.703125 6 10.5 6 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 4.505208 43.5 C 3.994792 43.5 3.489583 43.369792 3.041667 43.119792 C 2.59375 42.869792 2.21875 42.510417 1.953125 42.078125 C 1.682292 41.640625 1.53125 41.145833 1.505208 40.635417 C 1.484375 40.125 1.588542 39.614583 1.817708 39.15625 L 5.489583 33.317708 C 5.989583 32.317708 6.755208 31.479167 7.703125 30.895833 C 8.651042 30.3125 9.744792 30 10.859375 30 L 37.140625 30 C 38.255208 30 39.348958 30.3125 40.296875 30.895833 C 41.244792 31.479167 42.010417 32.317708 42.505208 33.317708 L 46.182292 39.15625 C 46.40625 39.614583 46.515625 40.125 46.494792 40.635417 C 46.46875 41.145833 46.317708 41.640625 46.046875 42.078125 C 45.78125 42.510417 45.40625 42.869792 44.958333 43.119792 C 44.510417 43.369792 44.005208 43.5 43.494792 43.5 Z M 4.505208 43.5 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 21 37.5 L 27 37.5 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 16.5 12 C 16.015625 12 15.541667 12.119792 15.114583 12.34375 C 14.6875 12.572917 14.317708 12.895833 14.041667 13.296875 C 13.765625 13.692708 13.59375 14.151042 13.536458 14.630208 C 13.473958 15.109375 13.53125 15.598958 13.703125 16.052083 L 16.317708 23.026042 C 16.421875 23.3125 16.614583 23.557292 16.864583 23.729167 C 17.114583 23.90625 17.411458 24 17.713542 24 L 30.635417 24 C 30.942708 24 31.239583 23.90625 31.489583 23.729167 C 31.739583 23.557292 31.932292 23.3125 32.036458 23.026042 L 34.65625 16.052083 C 34.822917 15.598958 34.880208 15.109375 34.822917 14.630208 C 34.760417 14.145833 34.583333 13.6875 34.307292 13.291667 C 34.03125 12.890625 33.666667 12.567708 33.234375 12.34375 C 32.807292 12.119792 32.328125 12 31.84375 12 Z M 16.5 12 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 24 17 L 24 19 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 20 17 L 20 19 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 28 17 L 28 19 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 16.671875 12 L 19.671875 4.5 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3Cpath style='fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(91.764706%25,13.333333%25,18.431373%25);stroke-opacity:1;stroke-miterlimit:4;' d='M 31.671875 12 L 28.671875 4.5 ' transform='matrix(0.75,0,0,0.75,0,0)'/%3E%3C/g%3E%3C/defs%3E%3Cg id='surface1'%3E%3Cuse xlink:href='%23surface6' mask='url(%23mask0)'/%3E%3C/g%3E%3C/svg%3E%0A");
    }
  }
  .card-footer {
    .title {
      span {
        font-size: 13px !important;
      }
    }
  }
}

@media screen and (max-width: 451px) {
  .card-content {
    &-result {
      strong {
        font-size: 13px !important;
      }
    }
  }
  .card-footer {
    .title {
      span {
        font-size: 10px !important;
      }
    }
  }
}
</style>
